import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('Cars-index-1992f2b720fdac951-1'),
    routerUrl: '/Cars',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Cars')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('Cars-index-1992f2b720fdac951-2'),
        routerUrl: '/CarsForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./CarsForm')),
      },
      //$MORE$
    ],
  },
];
